const formatKpiValue = (
    value: number | string | null,
    format?: string,
): string => {
    if (value == null) return '—';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return String(value);

    switch (format) {
        case 'currency':
        case 'number':
            return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        case 'percent':
            return `${num.toFixed(1)}%`;
        default:
            return num.toLocaleString();
    }
};

export default formatKpiValue;
